import qs from 'Utils/qs';
import Config from 'Config';

// Keys that are GAM standard top-level params (not custom targeting)
const GAM_STANDARD_KEYS = new Set([
  'iu', 'tfcd', 'npa', 'sz', 'gdfp_req', 'output',
  'unviewed_position_start', 'env', 'impl', 'correlator',
  'description_url', 'vpa', 'vpmute', 'plcmt',
]);

const videoAdTagUrl = (additionalParams = {}) => {
  const adTagUrlParams = {
    iu: Config.VIDEO_AD_TAG_IU,
    tfcd: 0,
    npa: 0,
    sz: '640x480',
    ad_type: 'video',
    gdfp_req: 1,
    output: 'vast',
    unviewed_position_start: 1,
    env: 'vp',
    impl: 's',
    correlator: '',
  };

  // Separate custom targeting params from standard GAM params.
  // GAM only reads custom targeting from the cust_params key.
  const custParts = [];
  Object.entries(additionalParams).forEach(([key, value]) => {
    if (GAM_STANDARD_KEYS.has(key)) {
      adTagUrlParams[key] = value;
    } else if (value !== undefined && value !== null && value !== '') {
      const v = Array.isArray(value) ? value.join(',') : value;
      custParts.push(`${encodeURIComponent(key)}=${encodeURIComponent(v)}`);
    }
  });

  if (custParts.length > 0) {
    adTagUrlParams.cust_params = custParts.join('&');
  }

  const baseAdTagUrl = 'https://pubads.g.doubleclick.net/gampad/ads';
  return `${baseAdTagUrl}?${qs.stringify(adTagUrlParams)}`;
};

export default videoAdTagUrl;
